<script setup>
const imgNoAvatar = new URL('@/assets/svg/icons/no-avatar.svg', import.meta.url).href;

const props = defineProps({
  avatar: {
    type: String,
    default: '',
    required: false,
  },
  mailAdress: {
    type: String,
    default: 'info@alpinaonline.nl',
    required: false,
  },
  phoneNumber: {
    type: String,
    default: '0612345678',
    required: false,
  },
});

const imgAvatar = props.avatar === '' ? imgNoAvatar : props.avatar;

const openTrengo = () => {
  document.querySelector('.trengo-chat-button').click();
};
</script>

<template>
  <div>
    <h3
      class="b-contact__title"
      v-html="$t('general.contact.title', { tagopen: '<span>', tagclose: '</span>' })"
    />
    <div
      id="accordionContact"
      class="accordion accordion-flush b-contact__wrapper"
    >
      <div class="b-contact__avatar">
        <img
          :src="imgAvatar"
          alt="Avatar"
          width="66"
          height="66"
        >
      </div>
      <div class="b-contact__content">
        <div class="b-contact__text">
          <p>{{ $t('general.contact.body') }}</p>
        </div>
        <div class="accordion-item b-contact__collapsible">
          <div
            id="headingChat"
            class="accordion-header"
          >
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseChat"
              aria-expanded="false"
              aria-controls="collapseChat"
            >
              <BaseIconWithLabel
                image-name="/svg/signal.svg"
                before
                small
              >
                <strong> {{ $t('general.contact.chatTitle') }}</strong>
              </BaseIconWithLabel>
            </button>
          </div>
          <div
            id="collapseChat"
            class="accordion-collapse collapse"
            aria-labelledby="headingChat"
            data-bs-parent="#accordionContact"
          >
            <div class="accordion-body">
              <p class="b-contact__text">
                {{ $t('general.contact.chatBody') }}
              </p>
              <a
                class="button button--right-skew button--right-skew--inverse button--white"
                @click="openTrengo()"
              >{{
                $t('general.contact.chatCTA')
              }}</a>
            </div>
          </div>
        </div>
        <div class="accordion-item b-contact__collapsible">
          <div
            id="headingEmail"
            class="accordion-header"
          >
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEmail"
              aria-expanded="false"
              aria-controls="collapseEmail"
            >
              <BaseIconWithLabel
                image-name="/svg/mail.svg"
                before
                small
              >
                <strong> {{ $t('general.contact.emailTitle') }}</strong>
              </BaseIconWithLabel>
            </button>
          </div>
          <div
            id="collapseEmail"
            class="accordion-collapse collapse"
            aria-labelledby="headingEmail"
            data-bs-parent="#accordionContact"
          >
            <div class="accordion-body">
              <p class="b-contact__text">
                {{ $t('general.contact.emailBody') }}
              </p>
              <a
                class="button button--right-skew button--right-skew--inverse button--white"
                data-modal-open="form"
                :href="`mailto:${mailAdress}`"
              >
                {{ $t('general.contact.emailCTA') }}</a>
            </div>
          </div>
        </div>
        <div class="accordion-item b-contact__collapsible">
          <div
            id="headingPhone"
            class="accordion-header"
          >
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsePhone"
              aria-expanded="false"
              aria-controls="collapsePhone"
            >
              <BaseIconWithLabel
                image-name="/svg/phone-call.svg"
                before
                small
              >
                <strong> {{ $t('general.contact.phoneTitle') }}</strong>
              </BaseIconWithLabel>
            </button>
          </div>
          <div
            id="collapsePhone"
            class="accordion-collapse collapse"
            aria-labelledby="headingPhone"
            data-bs-parent="#accordionContact"
          >
            <div class="accordion-body">
              <p class="b-contact__text">
                {{ $t('general.contact.phoneBody') }}
              </p>
              <a
                class="button button--right-skew button--right-skew--inverse button--white"
                :href="`tel:${phoneNumber}`"
              >
                {{ $t('general.contact.phoneCTA') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.b-contact {
  padding-bottom: 20rem;

  &__avatar {
    margin-right: 1.6rem;

    img {
      border-radius: 50%;
      width: 66px;
      height: 66px;
      object-fit: cover;
    }
  }

  &__title {
    margin: 0 8rem 1.6rem 0;
  }

  &__wrapper {
    display: flex;
    position: relative;
    --bs-accordion-active-color: unset;
    --bs-accordion-btn-focus-box-shadow: none;
  }

  &__content {
    background-color: #fff;
    border-radius: 0 16px 16px;
    padding: 1.6rem;
    box-shadow: 0 4px 32px rgba(0, 0, 0, 0.07);
    left: 8.5rem;
  }

  &__text {
    line-height: 1.333;
    margin-right: 3rem;

    span {
      color: var(--theme-font-color-accent-100);
    }
  }

  &__collapsible {
    margin-top: 0.9rem;
    border-bottom: none;

    img {
      margin-right: 0.8rem;
    }
  }
}
</style>
